import { render, staticRenderFns } from "./AtcMultipleProducts.vue?vue&type=template&id=6bb5337a&scoped=true&"
import script from "./AtcMultipleProducts.vue?vue&type=script&lang=js&"
export * from "./AtcMultipleProducts.vue?vue&type=script&lang=js&"
import style0 from "./AtcMultipleProducts.vue?vue&type=style&index=0&id=6bb5337a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5337a",
  null
  
)

export default component.exports